/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shipment_Tracking_Not_AllowedInputs */

const en_error_shipment_tracking_not_allowed = /** @type {(inputs: Error_Shipment_Tracking_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking cannot be recorded here: the order is ex works, the shipment is cancelled, or the warehouse or TLG Shipping booked it.`)
};

/**
* | output |
* | --- |
* | "Tracking cannot be recorded here: the order is ex works, the shipment is cancelled, or the warehouse or TLG Shipping booked it." |
*
* @param {Error_Shipment_Tracking_Not_AllowedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_shipment_tracking_not_allowed = /** @type {((inputs?: Error_Shipment_Tracking_Not_AllowedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shipment_Tracking_Not_AllowedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_shipment_tracking_not_allowed(inputs)
});